import { SchemaURLParameterDefinition } from './SchemaDefinition'
import { URLParameterDefinition } from './TypedDefinition'
import { URLParameterNode } from './TypedNode'
import { URLParameterModel } from './ViewModel'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface URLParameterPluginProps {}

export class URLParameterPlugin implements RehajePlugin {
  props: URLParameterPluginProps

  visitors?: PluginVisitors = {
    definitions: {
      'Schema.URLParameter': SchemaURLParameterDefinition,
      URLParameter: URLParameterDefinition
    },
    models: {
      URLParameter: URLParameterModel
    },
    nodes: {
      URLParameter: URLParameterNode
    }
  }

  constructor(props?: URLParameterPluginProps) {
    this.props = { ...props }
  }
}
